module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/title_bg_3-594551ea1956eb8564e66839e28fcecf.svg";